<script>
  import VideoObject from "./VideoObject.svelte";
  import {External, M} from "../../external";
  import {
    defaultErrorHandling,
    deleteVideoService,
    getVideoService,
    patchVideoService, putVideoService, updateVideoMetadata, uploadVideo
  } from "../static";
  import VideoAnalytic from "../Analytic/VideoAnalytic.svelte";
  import VideoProperties from "./VideoProperties.svelte";
  import Loader from "../../Common/Loader.svelte";
  import {onDestroy} from "svelte";

  export let folder = {};
  export let allFolders = {};
  export let backToAllFolders;
  export let showSelect = false;
  export let selectVideo = () => {};
  export let renameFolder = (id) => {};
  let showLoader = true;

  let getFolderContents = () => {
    folder.videoFiles = [];
    getVideoService('/folder/' + folder.id)
        .then((folderVideos) => {
          if (folderVideos) {
            let totalDurationInMs = 0;
            folder.totalViews = 0;
            folder.uniqueViews = 0;
            for (const videoFile of folderVideos) {
              //check if video upload and conversion is complete
              if (videoFile.jobStatus !== 'COMPLETE' && videoFile.jobStatus !== 'ERROR') {
                addToCheckIfUploaded(folder.id, videoFile.id);
              }
              totalDurationInMs += videoFile.durationInMs;
              folder.totalViews += videoFile.totalViews;
              folder.uniqueViews += videoFile.uniqueViews;
            }
            let folderEngagement = (folder.playTimeInSeconds / (folder.totalViews * (totalDurationInMs / 1000))) * 100;
            if (folderEngagement && folderEngagement > 0) {
              folder['avgEngagement'] = folderEngagement.toFixed(2);
            } else {
              folder['avgEngagement'] = 0;
            }
            folder.videoFiles = folderVideos;
          } else {
            folder['avgEngagement'] = 0;
          }
          showLoader = false;
        })
        .catch(err => {
          defaultErrorHandling();
        });
  }

  $: getFolderContents();

  onDestroy(() => {
    if (uploadingVideos.isStarted) {
      clearInterval(uploadingVideos.jobId);
    }
  })

  let onVideoUploaded = (createdVideoObject) => {
    addToCheckIfUploaded(folder.id, createdVideoObject.id);
    if (!folder.videoFiles) {
      folder.videoFiles = [];
    }
    folder.videoFiles.push(createdVideoObject);
    folder.videoCount += 1;
    editVideoMeta(createdVideoObject.id);
  }

  let onVideoUploadFail = (createdVideoObjectId) => { //todo this seems obsolite as we are not adding video to folder if upload fails
    let video = folder.videoFiles.find(video => video.id !== createdVideoObjectId);
    if (video) {
      video.jobStatus = 'ERROR';
      folder = folder;
    }
  }

  let moveVideo = (oldFolderId, newFolderId, videoId) => {
    putVideoService('/file/' + videoId + '/move/folder/' + newFolderId)
        .then(() => {
          allFolders[newFolderId].videoCount += 1;
          allFolders[oldFolderId].videoCount -= 1;
          folder.videoFiles = folder.videoFiles.filter(video => video.id !== videoId);
        })
        .catch(err => defaultErrorHandling());
  }

  let removeVideo = (video) => {
    External.Tools.prompt(M.DELETE, External.format(M.DEL_CONFIRM_EXT, 'ext', video.name), () => {
      showLoader = true;
      deleteVideoService('/file/' + video.id)
          .then(() => {
            const ind = folder.videoFiles.findIndex(videoFile => videoFile.id === video.id);
            folder.videoFiles.splice(ind, 1);
            folder.videoCount -= 1;
            showLoader = false;
          })
          .catch(err => {
            defaultErrorHandling();
            showLoader = false;
          });
    })
  }

  let showAnalyticPopup = () => { //tod move this to static
    External.Tools.showWindow({
      title: '',
      height: 750,
      width: 1000,
      isModal: false,
      withDarkBackground: true,
      showCloseButton: true,
      action: {
        onShow: (popup, context) => {
          popup.bindComponent(
              new VideoAnalytic({
                target: popup.getContentArea(),
                props: {
                  id: folder.id,
                  type: 'folder'
                }
              })
          );
        }
      }
    });
  }

  let videoEditValueHolder= {};
  let videoEditPopup = null;

  let editVideoMeta = (videoObjectId) => { //todo UI is not refreshed when the changes are applied
    let videoObject = folder.videoFiles.find(video => video.id === videoObjectId);
    videoEditValueHolder = JSON.parse(JSON.stringify(videoObject));
    External.Tools.showWindow({
      title: '',
      noTitle: true,
      width: 700,
      forceAtRight: window.showBuilderPopupsOnFullHeight,
      isModal: true,
      withDarkBackground: true,
      buttons: [
        External.Button(M.OK, External.Button.CLASS_MIDDLE_BLUE, (popup) => {
          popup.close();
          updateVideoMetadata(videoObject.id, videoEditValueHolder, () => {
            for (let index in folder.videoFiles) {
              let vid = folder.videoFiles[index];
              if (vid.id === videoEditValueHolder.id) {
                videoEditValueHolder.updatedAt = new Date().toISOString();
                folder.videoFiles[index] = videoEditValueHolder;
                break;
              }
            }
            videoEditValueHolder = {};
          }).catch(err => {
            videoEditValueHolder= {};
            defaultErrorHandling();
          });
        }),
        External.Button(M.CANCEL, External.Button.CLASS_MIDDLE_GREY, (popup) => {
          videoEditValueHolder= {};
          popup.close();
        })
      ],
      action: {
        onShow: (popup, context) => {
          videoEditPopup = popup;
          popup.bindComponent(
              new VideoProperties({
                target: popup.getContentArea(),
                props: {
                  video: videoEditValueHolder,
                  onClose: () => {
                    videoEditPopup = null;
                    popup.close();
                  }
                }
              })
          );
        }
      }
    });
  }


  let uploadingVideos = {
    videosQueue: {},
    isStarted: false,
    jobId: null
  };

  let addToCheckIfUploaded = (fId, vId) => {
    let checkId = fId + '_' + vId;
    if (uploadingVideos.videosQueue[checkId]) {
      return;
    }
    uploadingVideos.videosQueue[checkId] = true;
    if (!uploadingVideos.isStarted) {
      uploadingVideos.isStarted = true;
      uploadingVideos.jobId = setInterval(() => {
        for (const videosQueueKey in uploadingVideos.videosQueue) {
          let tokens = videosQueueKey.split('_');
          let videoId = parseInt(tokens[1]);
          getVideoService('/file/' + videoId + '/job/status')
              .then(status => {
                if (status === 'COMPLETE' || status === 'ERROR') {
                  delete uploadingVideos.videosQueue[videosQueueKey];
                  //stop interval if there's no more videos in queue
                  if (Object.keys(uploadingVideos.videosQueue).length === 0) {
                    uploadingVideos.isStarted = false;
                    clearInterval(uploadingVideos.jobId);
                  }
                  //return newest video properties
                  return getVideoService('/file/' + videoId );
                }
              })
              .then(uploadedVideo => {
                if (!uploadedVideo) {
                  return;
                }
                //if user is still editing video properties
                if (videoEditValueHolder.id === uploadedVideo.id) {
                  //if user has already set properties for video, override it
                  if (videoEditValueHolder.thumbnail) {
                    uploadedVideo.thumbnail = videoEditValueHolder.thumbnail;
                    uploadedVideo.thumbnailFileBase = videoEditValueHolder.thumbnailFileBase;
                    uploadedVideo.thumbnailFileName = videoEditValueHolder.thumbnailFileName;
                  }
                  //title is either default of changed and persisted, that is we got either default or changed version, it's safe to overwrite
                  uploadedVideo.title = videoEditValueHolder.title;
                  //captions are either null or added, it's safe to overwrite them
                  uploadedVideo.captions = videoEditValueHolder.captions;
                  videoEditValueHolder = uploadedVideo;
                  if (videoEditPopup) {
                    videoEditPopup.component().$set({video: videoEditValueHolder});
                  }
                }
                for (let i = 0; i < folder.videoFiles.length; i++) {
                  if (folder.videoFiles[i].id === uploadedVideo.id) {
                    folder.videoFiles[i] = uploadedVideo;
                    folder.videoFiles = folder.videoFiles; //todo check if needed
                    break;
                  }
                }

              });
        }
      }, 30 * 1000);
    }
  }


</script>

<div>
  <div class="col20 f-left flex align-center space-between">
    <h5 on:click={backToAllFolders} style="cursor: pointer" class="blue-text"> &#8592; {M.BACK_TO_ALL_FOLDERS}</h5>
  </div>
  <div class="col20 f-left mt-15 flex align-center space-between mb-15">
    <div class="flex align-center flex-none">
      <h3 class="flex align-center folder-name">{folder.name}<a on:click={() => renameFolder(folder.id)} class="small-button blue rounded-effect ml-10 none-soft">{M.RENAME}</a></h3>
      <span class="video-stat-wrapper" style="margin: 0 0 0 15px;">{folder.videoFiles.length} {folder.videoFiles.length != 1 ? M.VIDEOS : M.VIDEO}</span>
    </div>
    <div class="flex-none">
      <a class="middle-button blue with-icon mr-5 f-right" on:click={() => uploadVideo(folder, onVideoUploaded, onVideoUploadFail)}>{M.UPLOAD_VIDEO}</a>
      <a class="middle-button light-gray-btn rounded-effect mr-5 f-right" on:click={showAnalyticPopup}>{M.ANALYTICS}</a>
    </div>
  </div>

  <div class="scrollable-table col20 f-left mb-25">
    {#if showLoader}
      <Loader />
    {:else if folder.videoFiles.length === 0}
      <div class="empty-folder-message col20 f-left">
        <span class="col20 f-left t-center">{M.EMPTY_FOLDER}</span>
        <div class="col20 f-left mt-35 t-center">
          <a class="middle-button blue with-icon f-none inline-block" on:click={() => uploadVideo(folder, onVideoUploaded, onVideoUploadFail)}>{M.UPLOAD_VIDEO}</a>
        </div>
      </div>
    {:else}
        {#each folder.videoFiles as videoFile}
          <VideoObject videoObject={videoFile}  folder={folder} videoFolders={allFolders} showSelect={showSelect}
                       selectVideo={selectVideo} moveVideo={moveVideo} showEditVideoMeta={editVideoMeta} removeVideo={removeVideo} />
        {/each}
    {/if}
  </div>
  <!-- Analytics Area
  <div class="flex col20 f-left padded-section-analytics-warapper mb-15">
    <div class="analytics-box with-right-border">
      <h3>Total Views</h3>
      <h2 class="col20 f-left f-28 gray-text"><b>{folder.totalViews}</b></h2>
    </div>
    <div class="analytics-box with-right-border">
      <h3>Engagement</h3>
      <h2 class="col20 f-left f-28 gray-text"><b>{folder.avgEngagement}%</b></h2>
    </div>
    <div class="analytics-box with-right-border">
      <h3>Unique Views</h3>
      <h2 class="col20 f-left f-28 gray-text"><b>{folder.uniqueViews}</b></h2>
    </div>
    <div class="analytics-box">
      <h3>Time Played</h3>
      <h2 class="col20 f-left f-28 gray-text"><b>{formatSecondsTimeStamp(folder.playTimeInSeconds)}</b></h2>
    </div>
  </div>
  Analytics Area END-->
</div>
